import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth is now stored in an httpOnly cookie set by the backend (XSS-resistant).
// We only keep a non-sensitive copy of the user profile in localStorage so the
// initial paint after refresh doesn't flash a "Loading…" state. The actual
// authorisation is gated by the cookie on every request.
const USER_KEY = "wl_user";

export function getStoredUser() {
  try { return JSON.parse(localStorage.getItem(USER_KEY) || "null"); } catch { return null; }
}
export function setStoredUser(u) {
  if (u) localStorage.setItem(USER_KEY, JSON.stringify(u));
  else localStorage.removeItem(USER_KEY);
}

// `withCredentials: true` is what makes the browser send the httpOnly auth cookie
// (and receive Set-Cookie headers). Required for the cookie-based auth flow.
export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // Token invalid/expired → drop the cached user profile so the UI redirects.
      setStoredUser(null);
    }
    return Promise.reject(err);
  }
);

export async function logout() {
  try { await api.post("/auth/logout"); } catch (e) { console.error("[auth] logout failed", e); }
  setStoredUser(null);
}
